import { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ignoreTenant } from '@core/requests/tenant.interceptor'

export class CustomTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    public prefix = 'assets/i18n/',
    public suffix = '.json',
  ) {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`${this.prefix}${lang}${this.suffix}`, {
      context: ignoreTenant(),
    })
  }
}
